var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWeight(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "#5D6B72",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.106 15.266L6.555 16.817L5.048 15.31C4.102 16.531 3.464 17.994 3.266 19.6H5.4V21.8H1V20.7C1 15.376 4.784 10.943 9.8 9.92V7.72L1 4.2V2H23V4.2L14.2 7.72V9.92C19.216 10.943 23 15.376 23 20.7V21.8H18.6V19.6H20.734C20.536 17.994 19.898 16.531 18.952 15.31L17.445 16.817L15.894 15.266L17.401 13.748C16.18 12.802 14.706 12.164 13.1 11.966V14.1H10.9V11.966C9.294 12.164 7.82 12.802 6.599 13.748L8.106 15.266ZM12 18.5C12.5835 18.5 13.1431 18.7318 13.5556 19.1444C13.9682 19.5569 14.2 20.1165 14.2 20.7C14.2 21.2835 13.9682 21.8431 13.5556 22.2556C13.1431 22.6682 12.5835 22.9 12 22.9C11.648 22.9 11.318 22.823 11.032 22.669L6.797 20.7L11.032 18.731C11.318 18.577 11.648 18.5 12 18.5Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWeight);
export default __webpack_public_path__ + "static/media/weight.d97e0422.svg";
export { ForwardRef as ReactComponent };